import styles from "./index.module.css";

export enum TabIdEnum {
  ACCESS_GRAPH = "access-graph",
  SUSPECT_TAGS = "suspect-tags",
  SUSPECT_BEHAVIOUR = "suspect-behaviour",
}

const tabs: {
  id: TabIdEnum;
  label: string;
  count?: number;
}[] = [
  { id: TabIdEnum.ACCESS_GRAPH, label: "Access Graph" },
  { id: TabIdEnum.SUSPECT_TAGS, label: "Suspect Tags" },
  { id: TabIdEnum.SUSPECT_BEHAVIOUR, label: "Suspect Behaviour" },
];

type Props = {
  activeTab: TabIdEnum;
  onChange: (tabId: TabIdEnum) => void;
};

const DisplayTabs = ({ activeTab, onChange }: Props) => {
  return (
    <div
      className={`${styles.tabsContainer} ${
        activeTab !== TabIdEnum.ACCESS_GRAPH ? styles.noHeaderText : ""
      }`}
    >
      <div className={styles.tabs}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              className={`${styles.tabItem} ${isActive ? styles.active : ""}`}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
              {tab.count != null && (
                <span className={styles.badge}>{tab.count}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DisplayTabs;
